// extracted by mini-css-extract-plugin
export default {"popularLinksHeader":"styles_popularLinksHeader__Rswuh","popularLinksTitle":"styles_popularLinksTitle__yMj6a"};